import React from "react";
import { Route } from "react-router-dom";
import ErrorPage from "../ErrorPage/ErrorPage";

const ProtectedRoute = ({ component: Component, hasAccess, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (hasAccess ? <Component {...props} /> : <ErrorPage />)}
  />
);

export default ProtectedRoute;
